<script>
export default {
  name: "driverRechargeList",
  props: {
    driverData: {
      default: () => {
        return {};
      },
    },
    hideTitle: {
      default: false
    }
  },
  data() {
    return {
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/driver/balance/flowing",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            name: "明细类型",
            field: 'type',
            value: "",
            option: this.$const.RECHARGETYPE,
          },
          {type: "datetime", field: "time", name: "明细时间", value: []},
        ]
      },
      columns: [
        {prop: "type", label: "类型", width: 80},
        {prop: "fee", label: "金额", width: 80},
        {prop: "remark", label: "说明"},
        {prop: "created", label: "时间", width: 140},
        {prop: "paymentReceivingTime", label: "是否入账", width: 90},
        {prop: "operatorName", label: "操作人", width: 80},
      ],
    }
  },
  created() {
    this.customOptions.params.driverId = this.driverData.id;
  }

}
</script>

<template>
  <div class="driverRechargeList" style="height: calc(100% - 50px);">
    <div class="title" style="margin-bottom: 20px" v-if="!hideTitle">
      <span> 余额明细 </span>
    </div>
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :has-organization="false">

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
            row.created | filterTime
          }}
        </template>
        <template v-else-if="item.prop === 'type'">{{
            row.type | filterConst('RECHARGETYPE')
          }}
        </template>
        <template v-else-if="item.prop === 'paymentReceivingTime'">
          <span v-if="row.paymentReceivingTime">否</span>
          <span v-else>是</span>
        </template>
        <template v-else-if="item.prop === 'fee'">
          <span class="util-money" v-if="[2,3,5,7].includes(row.type)"> +¥{{ row.fee }}</span>
          <span class="util-money-minus" v-else-if="[4,6,].includes(row.type)">-¥{{ row.fee }} </span>
          <span class="util-money-minus" v-else-if="[8].includes(row.type)">¥{{ row.fee }} </span>
          <span v-else class="util-">{{ row.fee }} </span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

  </div>
</template>

<style scoped lang="less">
.driverRechargeList {
  .title {
    border-left: 3px solid #409efc;
    color: #333333;
    width: 550px;
    height: 20px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1;
    color: #333333;
    opacity: 1;
    text-indent: 1rem;
    display: flex;
    justify-content: space-between;
    overflow: inherit;


  }
}


</style>